import React from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function SolutionSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation(0.1);
  return <section className="py-16 md:py-24 bg-gradient-to-b from-[#0A0A0A] to-[#150B24] relative" data-id="element-228">
      <div className="container mx-auto px-4 text-center" data-id="element-229">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-230">
          <h2 className="text-3xl md:text-6xl font-bold mb-4 md:mb-6" data-id="element-231">
            La Solución:{' '}
            <span className="text-purple-500" data-id="element-232">Techain Ad Angle</span>
          </h2>
          <h3 className="text-lg md:text-2xl text-purple-200/80 font-light mb-8 md:mb-12" data-id="element-233">
            Sistema de Volumen Extremo para productos digitales
          </h3>

          <div className="max-w-3xl mx-auto bg-white/5 border border-white/10 rounded-2xl p-6 md:p-12 mb-12 md:mb-16 backdrop-blur-sm" data-id="element-234">
            <p className="text-xl md:text-3xl font-medium leading-relaxed" data-id="element-235">
              Genera{' '}
              <span className="text-white font-bold" data-id="element-236">
                100 creativos estáticos en ~10 minutos
              </span>
              . <br data-id="element-237" />
              Listos para testear en{' '}
              <span className="text-blue-400 font-bold" data-id="element-238">Meta Ads</span>.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-4xl mx-auto" data-id="element-239">
            {[{
            val: '100+',
            label: 'Creativos'
          }, {
            val: '10 Min',
            label: 'Tiempo Promedio'
          }, {
            val: '5+',
            label: 'Ángulos de Venta'
          }].map((stat, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.8
          }} animate={isVisible ? {
            opacity: 1,
            scale: 1
          } : {}} transition={{
            delay: 0.3 + i * 0.1,
            duration: 0.5
          }} className="p-4 md:p-6" data-id="element-240">
                <div className="text-5xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-b from-white to-purple-400 mb-2 font-sora" data-id="element-241">
                  {stat.val}
                </div>
                <div className="text-gray-400 uppercase tracking-wider text-xs md:text-sm font-bold" data-id="element-242">
                  {stat.label}
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}